import Tooltip from "@mui/material/Tooltip";
import React from "react";
import SpeechRecognition from "react-speech-recognition";
import { isEdgeChromium } from "../../../utils/util";
import { StyledSpeechToText } from "../../styled/speechToText";
import VoiceVisualization from "./voiceVisualization";

const SpeachToText = ({ listening, setIsSelected, transcript, disabled }) => {
  if (
    !SpeechRecognition.browserSupportsSpeechRecognition() ||
    isEdgeChromium()
  ) {
    return null;
  }

  const start = () => {
    if (!disabled) {
      setIsSelected(true);
      SpeechRecognition.startListening({
        language: "es-AR",
      });
    }
  };

  return (
    <div>
      <StyledSpeechToText.Container>
        <Tooltip title="Dictado por voz">
          <StyledSpeechToText.Mic onClick={start} disabled={disabled} />
        </Tooltip>
      </StyledSpeechToText.Container>
      <VoiceVisualization listening={listening} transcript={transcript} />
    </div>
  );
};
export default SpeachToText;
